<template>
  <transition name="share-images-modal">
    <list-input-modal
      v-if="modalVisible"
      :words="[]"
      :loading="shareLoading"
      :can-confirm="mediaList.length > 0"
      i18n-namespace="shareImagesModal"
      input-type="email-address"
      @confirm="onShareImageModalConfirm"
      @close="onShareImageModalClose"
    >
      <template #beforeListInput>
        <div
          class="columns is-variable is-1 is-multiline images-wrapper mb-2 mt-2"
          :class="{ 'has-background-white-ter': mediaList.length > 0 }"
        >
          <div v-for="medium in mediaList" :key="medium.id" class="column is-3 pt-1 pb-1">
            <div class="preview-image">
              <auth-image :src="medium.url_thumb" />
              <div class="preview-image-button-wrapper">
                <button
                  class="button is-small is-danger"
                  @click="() => onMediumRemove(medium)"
                >
                  {{ $t('shareImagesModal.removeItem') }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="mediaList.length === 0" class="column is-full pt-1 pb-1">
            <p class="has-text-warning">
              {{ $t('shareImagesModal.emptyList') }}
            </p>
          </div>
        </div>
        <p>
          {{ $t('shareImagesModal.sendToLabel') }}
        </p>
      </template>

      <template #afterListInput>
        <div class="mt-4">
          <textarea
            v-model="message"
            class="textarea"
            rows="3"
          ></textarea>
        </div>
      </template>
    </list-input-modal>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
const ListInputModal = () => import('@/components/ListInputModal.vue')
const AuthImage = () => import('@/components/commons/AuthImage/Single.vue')

export default {
  name: 'ShareImagesModal',
  components: { ListInputModal, AuthImage },
  data() {
    return {
      shareLoading: false,
      message: this.$i18n.t('shareImagesModal.messageTemplate')
    }
  },
  computed: {
    ...mapGetters({
      modalVisible: 'share_images_cart/cartOpen',
      mediaList: 'share_images_cart/mediaList'
    })
  },
  methods: {
    onMediumRemove(medium) {
      this.$store.commit('share_images_cart/removeMedium', medium)
    },
    onShareImageModalConfirm(recipient_emails) {
      const ids = this.mediaList.map(({ id }) => id)
      this.shareLoading = true

      this.$repositories()
          .media
          .share(ids, this.message, recipient_emails)
          .then(() => ( this.$_notify({ text: this.$t('shareImagesCart.messages.images_shared'), type: 'success' }) ))
          .then(() => {
            this.onShareImageModalClose()
            this.$store.commit('share_images_cart/resetMediaList')
          })
          .finally(() => ( this.shareLoading = false ))
    },
    onShareImageModalClose() {
      this.message = this.$i18n.t('shareImagesModal.messageTemplate')
      this.$store.dispatch('share_images_cart/closeCart')
    }
  }
}
</script>
<style lang="scss">
.images-wrapper {
  max-height: 50vh;
  overflow-y: scroll;
}

.preview-image {
  position: relative;

  & > .preview-image-button-wrapper {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.1);
    transition: opacity 0.2s ease;
  }

  &:hover > .preview-image-button-wrapper {
    opacity: 1;
  }
}

.share-images-modal-enter-active, .share-images-modal-leave-active {
  transition: all 0.2s;
}
.share-images-modal-enter, .share-images-modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
